import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { fetchOnDemandSession, FetchOnDemandSession } from './fetchOnDemandSession';

type UseOnDemandSession = (args: {
    eventId: number;
    sessionId: number;
    options?: UseQueryOptions<FetchOnDemandSession, AxiosError>;
}) => {
    data: FetchOnDemandSession | null;
    error: AxiosError;
    isLoading: boolean;
};

const useOnDemandSession: UseOnDemandSession = ({ eventId, sessionId, options = {} }) => {
    const { data, error, isLoading } = useQuery<FetchOnDemandSession, AxiosError>(
        ['onDemandSession', eventId, sessionId],
        () => fetchOnDemandSession(eventId, sessionId),
        {
            retry: 0,
            ...options,
        }
    );

    return {
        data,
        error,
        isLoading,
    };
};

export default useOnDemandSession;
